import {
  fetchPublicWebV1Search,
  TPublicWebV1SearchRequest,
  TPublicWebV1SearchResponse,
} from '../../repositories/dailyrent/web/v1/search';
import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../utils/errors/ResponseError';

export async function fetchListingOffers(context: IApplicationContext, parameters: TPublicWebV1SearchRequest) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode } = (await fetchPublicWebV1Search({
      httpApi,
      parameters,
    })) as TPublicWebV1SearchResponse;

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchListingOffers',
        message: response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.errors) },
      });
    }

    return response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
